<ng-container *ngxPermissionsOnly="['viewExportAccounts']">
    <ng-container *ngIf="isLink; else asButton">
        <div class="export-link" (click)="exportCSV()">
            <p>
                <span>Export {{ config.dataType }}</span>
                <mat-icon>open_in_new</mat-icon>
            </p>
        </div></ng-container
    >
    <ng-template #asButton>
        <div class="export-button">
            <button [disabled]="!hasData" mat-raised-button (click)="exportCSV()">Export {{ config.dataType }}</button>
        </div>
    </ng-template>
</ng-container>
